export default {
  'exhibitor_invitation_record': 'Invitation management',
  'exhibitor_invitation_record2': 'Invitation management(Sent list)',
  'only_visitors': 'Only visitors who have registered through their own invitation letter can join the client pool',
  'join_the_customer_pool': 'Join the customer pool',
  'audience_name': 'audience name',
  'email': 'E-mail',
  'status': 'Login/register via invitation',
  'invitation_date': 'invitation date',
  'register_date': 'Login/register date',
  'registered': 'registered',
  'unregistered': 'unregistered'
}